import React from 'react'
import "./Common_download_btn.css"
import { Link } from 'react-router-dom'

function Common_download_btn() {
  return (
    <>
      <div className='Common_download_btn'>
        <Link to={"https://play.google.com/store/apps/details?id=com.urban_build"} target='_blank'>
          <button className='common-btn'>
            <img
              src="/assets/images/icons/play.png"
              alt="Play Store"
              className='play_btn_icon'
            />
            <span>Download Now</span>
          </button>
        </Link>
      </div>
    </>
  )
}

export default Common_download_btn